import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { BRAND_ICONS_URLS } from "../../../utils/Constants";
import { AppStrings } from "../../../utils/constants/AppStrings";

const SiderHeader = ({ isExpanded, onHomeClick, onToggle }) => {
  const toggleLabel = isExpanded ? AppStrings.COLLAPSE : AppStrings.EXPAND;

  return (
    <div className="sider-header">
      <button
        type="button"
        className="sider-brand"
        aria-label={AppStrings.PAM_APP_NAME}
        onClick={onHomeClick}
      >
        <span className="sider-brand-logo">
          <img
            src={
              process.env.REACT_APP_ADMIN_PANEL_CLOUDFRONT_URL +
              BRAND_ICONS_URLS.topLeftAppIcon
            }
            alt=""
          />
        </span>
        <span className="sider-brand-name">{AppStrings.PAM_APP_NAME}</span>
      </button>

      <Tooltip title={toggleLabel} placement="right">
        <button
          type="button"
          className="sider-collapse-button"
          aria-label={toggleLabel}
          onClick={onToggle}
        >
          {isExpanded ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
        </button>
      </Tooltip>
    </div>
  );
};

export default SiderHeader;
